<template>
  <details class="sp-legend" :class="`sp-legend--${align}`">
    <summary>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6M12 7.5h.01" />
      </svg>
      Legend
    </summary>
    <div class="sp-legend__menu">
      <div v-for="item in items" :key="item.key" class="sp-legend__row">
        <i class="sp-legend__marker" :class="`sp-legend__marker--${item.tone}`" />
        <strong>{{ item.label }}</strong>
        <span>{{ item.description }}</span>
      </div>
    </div>
  </details>
</template>

<script>
export default {
  name: 'ShiftPlannerLegendDropdown',
  props: {
    items: {
      type: Array,
      required: true,
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'right'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>
.sp-legend {
  position: relative;
  z-index: 5;
}

.sp-legend summary {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid $ui-line-strong;
  border-radius: 8px;
  background: $ui-surface-soft;
  color: $ui-ink;
  font-family: $ui-font-body;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  list-style: none;
}

.sp-legend summary::-webkit-details-marker {
  display: none;
}

.sp-legend summary svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  fill: none;
  stroke: $ui-blue;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.sp-legend__menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 430px;
  max-width: calc(100vw - 32px);
  padding: 10px;
  border: 1px solid $ui-line;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 14px 34px rgba(28, 45, 74, 0.14);
}

.sp-legend--right .sp-legend__menu {
  right: 0;
  left: auto;
}

.sp-legend__row {
  display: grid;
  align-items: center;
  gap: 8px;
  padding: 7px 6px;
  font-size: 14px;
  grid-template-columns: 18px 120px minmax(0, 1fr);
}

.sp-legend__row span {
  color: $ui-muted;
}

.sp-legend__marker {
  width: 15px;
  height: 9px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: #dfe4eb;
}

.sp-legend__marker--day {
  background: #4c8ce8;
}

.sp-legend__marker--night {
  background: #6c5bc7;
}

.sp-legend__marker--worked {
  border-color: #b9cde8;
  background: #f6f9fd;
}

.sp-legend__marker--heavy {
  border-color: #e2aaa4;
  background: #fff3f2;
}

.sp-legend__marker--day-off,
.sp-legend__marker--covered {
  border-color: #79c7a9;
  background: $ui-green-soft;
}

.sp-legend__marker--leave-approved {
  border-color: #e2b75f;
  background: $ui-amber-soft;
}

.sp-legend__marker--leave-requested {
  border-color: #9f90dd;
  background: #f5f2ff;
}

.sp-legend__marker--deficit {
  border-color: #efb2ba;
  background: $ui-red-soft;
}

.sp-legend__marker--full,
.sp-legend__marker--locked {
  border-color: #cbd0d8;
  background: #e5e8ed;
}

.sp-legend__marker--today {
  border-color: #53ad88;
  background: #f4fbf7;
}

.sp-legend__marker--locked {
  opacity: 0.45;
}

@media (max-width: 560px) {
  .sp-legend--right .sp-legend__menu {
    right: auto;
    left: 0;
  }
}
</style>
